// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d212f89e","455":"e851e7cb","977":"9261019e"}[chunkId] + ".chunk.js";
};